import * as d3 from "d3";

export default () => {
    return { d3 };
};
